(function () {
	// show logged in status
	// get an element with the class wp-admin 
	var wpAdmin = document.querySelector('.wp-admin');


	if (!wpAdmin) {

		window.respOutput = '';
		var loginBtn = document.querySelector('#login-menu li.login a');
		var loginContainer = document.querySelector('#login-menu li.login');

		BL.logged_in_status = function (response) {
			loginContainer.classList.add('active');

			if (response.loggedIn) {
				loginBtn.innerHTML = 'Your Account';
			}
			window.logArr = response.loggedIn;
		};

		var script = document.createElement('script');
		script.src = BL.toolsBaseUrl + '/seo-tools/admin/corp/logged-in?callback=BL.logged_in_status';
		document.head.appendChild(script);
	}
})();